<template>
  <div>
    <label :for="id">{{ label }}</label>
    <div class="nt-input" :class="[{ 'nt-input--error': error }, { 'nt-input--rounded': rounded }, getTheme]">
      <input :id="id" :name="id" ref="input" type="text" :placeholder="placeholder" v-model.trim="selected" @change="changeForm" maxlength="100" v-on:keypress="keypress" @keydown.enter="enterClicked" @blur="validateOnBlur">
      <button v-if="buttonSubmit" ref="submit" id="btn-submit" class="button button--default" @click.prevent="onSubmit">{{ buttonSubmit }}</button>
    </div>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
    <div class="nt-form-text-helper" v-if="helperText">{{ helperText }}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'nt-input',
  props: {
    id: {
      type: String,
      default: 'input'
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    validators: {
      type: Array,
      default: []
    },
    regex: {
      type: String,
      default: '(.*?)'
    },
    rounded: {
      type: Boolean,
      default: false
    },
    buttonSubmit: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'default'
    },
    helperText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: null,
      error: null
    }
  },
  watch: {
    '$parent.errors': {
      handler(values) {
        const errorObj = _.find(values, (obj) => Object.prototype.hasOwnProperty.call(obj, this.id))
        this.error = errorObj ? errorObj[this.id] : null
      },
      deep: true
    }
  },
  computed: {
    getTheme() {
      return `nt-input--${this.theme}`
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data
    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.selected
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
  },
  mounted() {
    if (this.buttonSubmit && window.innerWidth > 992) {
      this.$refs.input.style.paddingRight = `${this.$refs.submit.clientWidth + 20}px`
    }
  },
  methods: {
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.selected
      })
    },
    keypress(event) {
      if (this.regex && !event.key.match(this.regex)) {
        event.preventDefault()
      }
    },
    onSubmit() {
      this.$parent.$emit('formSubmit')
    },
    enterClicked(event) {
      event.preventDefault()
      if (this.buttonSubmit) {
        this.changeForm()
        this.onSubmit()
      }
    },
    validateOnBlur() {
      this.changeForm()
      this.$parent.$emit('field-blur', this.id)
    },
  }
}
</script>

<style lang="scss" scoped>
  .nt-input {
    &--small {
      input {
        padding: 10px;
        font-size: 1rem;
      }
    }
  }
</style>
